<template src="./Index.html">
</template>


<script>

export default {
  components: {
  
  },
  created() {
    this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.specializations.totalItems / this.filters.pageSize
      );
    },
    specializations() {
      return this.$store.state.specializations.specializations;
    },

  },

  data() {
    return {
      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      formDialog: false,
     
      filters: {
        page: 1,
        pageSize: 10,
      },

      headers: [
        { text: 'اسم التخصص ', value: 'specialtyName' },
         { text: "مسجل بواسطة", value: "createdBy", sortable: false },
         { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        // { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("specializations/getAll", this.filters);
    },

    addItem() {
      this.view = 1;
      this.formDialog = true;
    },

    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      this.formDialog = true;
      // Implement view logic
    },

    editItem(item) {
      this.itemId = item.id;
      this.department.departmentName = item.departmentName; //
      this.view = 2;
      this.formDialog = true;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`departments/delete`, this.itemId);
    },
    back() {
      this.view = 0;
    },
    // --------------------------form dilog ------------------------------- //

    confirmFormDialog() {

      // this.$store
      //     .dispatch("administrations/add",{
      //         id:this.itemId,
      //         payload :this.department
      //     }) 
      //     .then(() => {
      //         this.cancelEmployee()
      //     })
      //     .catch(() => { });
      this.cancelFormDialog()
    },
    cancelFormDialog() {
      this.formDialog = false;
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        // case "lock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
        //     break;
        // case "unlock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
        //     break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`departments/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },

  },
};
</script>

<style scoped></style>